import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaLightbulb, FaTools, FaChartLine } from 'react-icons/fa';
import './Consultancy.css';

const Consultancy = () => {
  const services = [
    {
      icon: <FaLightbulb />,
      title: 'Initial Consultation',
      description: 'We begin with understanding your vision, requirements, and budget to create a tailored solution.'
    },
    {
      icon: <FaTools />,
      title: 'System Design',
      description: 'Our experts design a comprehensive system that integrates seamlessly with your space and lifestyle.'
    },
    {
      icon: <FaChartLine />,
      title: 'Project Management',
      description: 'From planning to execution, we manage every aspect of your audio-visual project.'
    }
  ];

  return (
    <div className="consultancy-page">
      {/* Hero Section */}
      <section className="consultancy-hero">
        <div className="consultancy-hero-overlay"></div>
        <div className="consultancy-hero-content">
          <h1>Audio Visual Consultancy</h1>
          <p>
            Turn Dreams into Reality! Elevate Your Entertainment with Our Expert Home Audio Visual Consultants.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="consultancy-intro">
        <div className="container">
          <div className="intro-grid">
            <div className="intro-content">
              <h2>Expert Audio Visual Consultants</h2>
              <p>
                Sound Innovators is one of the premier Home Audio Visual Automation Consultants and Home Theatre 
                Installation Service in India. Our Head office is located in Mumbai, Maharashtra. The regional 
                office is in Pune, Maharashtra, but we serve clients across India.
              </p>
              <p>
                Uprise your Home Entertainment requirement with our experts to get personalized, unique solutions 
                for your luxurious home with compromising audio visual quality and home decor.
              </p>
            </div>
            <div className="intro-image">
              <img 
                src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&h=600&fit=crop&q=80" 
                alt="Audio Visual Consultation" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="consultancy-services">
        <div className="container">
          <div className="section-header">
            <h2>Our Consultancy Services</h2>
            <p>Comprehensive audio visual consultation from concept to completion</p>
          </div>
          <div className="values-grid">
            {services.map((service, index) => (
              <div className="value-card" key={index}>
                <div className="value-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="consultancy-process">
        <div className="container">
          <h2>Our Consultation Process</h2>
          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Initial Meeting</h3>
              <p>Schedule a consultation to discuss your vision and requirements</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Site Assessment</h3>
              <p>We visit your location to understand the space and acoustics</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Custom Proposal</h3>
              <p>Receive a detailed proposal with design and equipment recommendations</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Implementation</h3>
              <p>Professional installation and calibration by certified technicians</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="consultancy-cta">
        <div className="container">
          <h2>Ready to Transform Your Space?</h2>
          <p>Contact us today for a personalized consultation</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">Schedule Consultation</Link>
            <a href="tel:+919876543210" className="btn btn-secondary">Call Now</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Consultancy;
